import React, { Suspense, lazy } from 'react';
import PagePreloader from '~components/page-preloader';

const DocsItemPageToken = lazy(() => import('./index'))

function DocsItemPageTokenLazy(props) {
    return (
        <Suspense fallback={<PagePreloader />}>
            <DocsItemPageToken {...props} />
        </Suspense>
    );
}

export default DocsItemPageTokenLazy;
export { DocsItemPageTokenLazy };



// WEBPACK FOOTER //
// ./src/routes/docs-item-page-token/lazy.js